





























































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { THUMBNAIL_300, THUMBNAIL_400 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { formatCategory } from '~/utils/event';
import { EventSummaryResponseSchema } from '~/types/modules/event';
import { SeatsLeft, EventStatus } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<EventSummaryResponseSchema>,
      required: true,
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const displayStartDate = computed(() => dayjs(props.item.startDate || null));
    const displayEndDate = computed(() => {
      const endDate = dayjs(props.item.endDate || null);
      return endDate.isSame(displayStartDate.value) ? dayjs(null) : endDate;
    });

    const detailPath = computed(() => url('EVENT_DETAIL', { id: props.item.id }));

    const isCanceled = computed(() => props.item.status === EventStatus.CANCELED);

    return {
      displayStartDate,
      displayEndDate,
      detailPath,
      isCanceled,
      dayjs,
      SeatsLeft,
      formatCategory,
      THUMBNAIL_300,
      THUMBNAIL_400,
    };
  },
});
